import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const BaseTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.contrastDefault.main : theme.palette.tertiary.contrastText
}));

export {
    BaseTypography
};